const hasExistingQueryParam = (url: string) => url.indexOf("?") !== -1;

export const getQueryParamDelimiter = (url: string) => (hasExistingQueryParam(url) ? "&" : "?");

export const generateSrcSet = (srcSetSizes: number[], srcUrl: string) => {
    const generateSrcSetString = (srcSetSize: number) => {
        const parameterDelimiter = getQueryParamDelimiter(srcUrl);
        const srcSetSizeHighDensity = Math.round(srcSetSize * 1.5);

        return `
            ${srcUrl}${parameterDelimiter}w=${srcSetSize} ${srcSetSize}w,
            ${srcUrl}${parameterDelimiter}w=${srcSetSizeHighDensity} ${srcSetSizeHighDensity}w
        `;
    };

    return srcSetSizes.map(generateSrcSetString).join(", ");
};

export const generateColumnImageProps = (maxColumns: number, isFullWidth?: boolean) => {
    // The sizes are column-widths and are not considering padding
    const gridMaxWidthFactor = isFullWidth ? 1 : 0.75;
    const gridMaxWidth = 1366 * gridMaxWidthFactor;
    const defaultSize = gridMaxWidth / maxColumns;
    let sizes;

    switch (maxColumns) {
        case 5:
            sizes = `(max-width: 479px) 100vw, 
            (max-width: 639px) 75vw,
            (max-width: 767px) 50vw,
            (max-width: 1023px) ${100 / 3}vw,
            (max-width: 1099px) ${(100 / 3) * gridMaxWidthFactor}vw,
            (max-width: 1279px) ${(100 / 4) * gridMaxWidthFactor}vw,
            ${defaultSize}px`;
        case 4:
            sizes = `(max-width: 479px) 100vw, 
            (max-width: 639px) 75vw,
            (max-width: 767px) 50vw,
            (max-width: 1023px) ${100 / 3}vw,
            (max-width: 1099px) ${(100 / 3) * gridMaxWidthFactor}vw,
            (max-width: 1279px) ${(100 / 4) * gridMaxWidthFactor}vw,
            ${defaultSize}px`;
        case 3:
            sizes = `(max-width: 479px) 100vw,
            (max-width: 639px) 75vw,
            (max-width: 767px) 50vw,
            (max-width: 1023px) ${100 / 3}vw,
            (max-width: 1279px) ${(100 / 3) * gridMaxWidthFactor}vw,
            ${defaultSize}px`;
        case 2:
            sizes = `(max-width: 479px) 100vw,
            (max-width: 639px) 75vw,
            (max-width: 1023px) ${100 / 2}vw,
            (max-width: 1279px) ${(100 / 2) * gridMaxWidthFactor}vw, 
            ${defaultSize}px`;
        case 1:
            sizes = `(max-width: 479px) 100vw,
            (max-width: 1023px) ${100 * 0.75}vw,
            (max-width: 1279px) ${100 * 0.75 * gridMaxWidthFactor}vw,
            ${defaultSize * 0.75}px`;
    }

    return {
        // The sizes are column-widths and are not considering padding
        defaultSize: defaultSize,
        srcSetSizes: [205, 257, 274, 342, 456, 513, 683, 769, 1025],
        sizes: sizes
    };
};
